module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("添加结算信息")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_vm._m(0), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "text",
      "title": "结算银行卡号",
      "isMust": "true",
      "placeholder": "请输入结算账号"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "text",
      "title": "户名",
      "isMust": "true",
      "placeholder": "请输入开户名称"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "text",
      "title": "开户行",
      "isMust": "true",
      "placeholder": "请输入开户银行名称"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "text",
      "title": "开户行所在地",
      "isMust": "true",
      "placeholder": "请输入开户行地址"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fx  m-t-15"
  }, [_c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [(_vm.isMust) ? _c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]) : _vm._e()]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleAddBtn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_vm._v("商户名称")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("商户名称商户名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx-fill m-l-5"
  }, [_vm._v("\n\t\t\t\t\tT+"), _c('input', {
    staticClass: "number-style",
    attrs: {
      "type": "number",
      "name": "",
      "id": "",
      "value": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center m-t-15"
  }, [_c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")])]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("分润规则")])]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill fx fx-y-center"
  }, [_vm._v("每笔交易平台分润 "), _c('div', {
    staticClass: "w100"
  }, [_c('input', {
    staticClass: "input b-r-5",
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "value": ""
    }
  })]), _vm._v("%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx  m-t-15"
  }, [_c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_vm._v("订单退款时分润返还设置")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill m-l-5"
  }, [_c('label', {
    staticClass: "fx fx-y-center"
  }, [_c('input', {
    staticClass: "radio m-r-5 b-r-50",
    attrs: {
      "type": "radio",
      "name": "switch",
      "id": "",
      "value": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("不退分润"), _c('span', {
    staticClass: "c-g"
  }, [_vm._v("（对订单进行任何退款操作，均不返还分润给收款方）")])])]), _vm._v(" "), _c('label', {
    staticClass: "fx fx-y-center m-t-10"
  }, [_c('input', {
    staticClass: "radio m-r-5 b-r-50",
    attrs: {
      "type": "radio",
      "name": "switch",
      "id": "",
      "value": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("全额退还分润"), _c('span', {
    staticClass: "c-g"
  }, [_vm._v("（对订单进行任何退款操作，返还全部分润给收款方）")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-46ff85b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/shops/ClearInfo.vue
// module id = 836
// module chunks = 0